var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

export var mockApi = function () {
  function mockApi(type, attributes) {
    _classCallCheck(this, mockApi);

    this._attributes = attributes;
    this._data = null;
    this._type = type;
  }

  mockApi.prototype.convertAttributes = function convertAttributes() {
    var attrs = {};
    for (var i = 0; i < this._attributes.length; i++) {
      attrs[this._attributes[i]] = this._data[this._attributes[i]];
    }
    return attrs;
  };

  mockApi.prototype.post = function post() {
    return Promise.resolve({
      data: {
        attributes: this.convertAttributes(),
        id: this._store ? (this._store.getState().entities.get(this._type).size + 1).toString() : "1",
        type: this._type
      }
    });
  };

  mockApi.prototype.get = function get() {
    return Promise.resolve({
      data: this._data
    });
  };

  mockApi.prototype.delete = function _delete() {
    return Promise.resolve(true);
  };

  mockApi.prototype.payload = function payload(type, data) {
    this._data = data;
  };

  _createClass(mockApi, [{
    key: "store",
    set: function set(store) {
      this._store = store;
    }
  }]);

  return mockApi;
}();


//////////////////
// WEBPACK FOOTER
// ../ui-utilities/es/mock-api.js
// module id = 595
// module chunks = 4